import { useStats } from "../../../ducks/stats";
import PracticeCard from "./PracticeCard";

export default function InfoCardContainer() {
  const { chess, chess960 } = useStats();

  const props = {
    elo: chess.elo,
    elo960: chess960.elo,
  };

  return <PracticeCard {...props} />;
}
